import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AngularFirestoreCollection, AngularFirestore, AngularFirestoreDocument, QuerySnapshot, DocumentData, QueryDocumentSnapshot } from '@angular/fire/firestore';

@Component({
  selector: 'app-errores-archivo',
  templateUrl: './errores-archivo.component.html',
  styleUrls: ['./errores-archivo.component.scss']
})
export class ErroresArchivoComponent implements OnInit {

  public archivo: AngularFirestoreDocument;

  //public errores: Promise<QuerySnapshot<DocumentData>>;
  public errores: DocumentData[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.archivo = data.archivo;    
  }

  ngOnInit(): void {
    //this.errores = this.archivo.ref.collection('error').get();    
    this.archivo.ref
      .collection('error')
      .get()
      .then(
        (errores)=>{
          this.errores = errores.docs.map( 
            error => {
              return error.data().mensaje.split("::");
              //error.data().mensaje

            }
          )
          .sort(
            (a, b) => (parseInt(a[0]) - parseInt(b[0]))
          );
        }
      );

  }

}
